import { TYPE_DEVIS } from '@/configuration/devisConf';
import { SANS_SUITE, INDISPONIBLE, ANNULATION } from '@/configuration/optionBlocage/optionBlocage';
import isLigneRegroupement from '@/services/devisCommandes/isLigneRegroupement';

export default function miseAJourRepartitionTva(ligneCommande, devisCommande) {
  if (!devisCommande || !ligneCommande || !ligneCommande.tauxTva) {
    return;
  }

  if (devisCommande.type === TYPE_DEVIS
    && isLigneRegroupement(devisCommande, ligneCommande.referenceRegroupement)
    && (ligneCommande.etatObtenu === SANS_SUITE
    || ligneCommande.etatObtenu === INDISPONIBLE
    || ligneCommande.etatObtenu === ANNULATION)) return;

  const tauxTva = devisCommande.repartitionsTva.find((el) => {
    return el.tauxTva === ligneCommande.tauxTva;
  });
  if (!tauxTva) {
    const nouveauTauxTva = {
      devisCommandeId: devisCommande.Id,
      tauxTva: ligneCommande.tauxTva,
      totalHt: ligneCommande.totalHtAvecLigneRemise,
      totalTva: null,
    };
    devisCommande.repartitionsTva.push(nouveauTauxTva);
  } else {
    tauxTva.totalHt += ligneCommande.totalHtAvecLigneRemise;
  }
}
